export default "__VITE_ASSET__CMmTPx6p__"